import React, { Component } from "react";

import dataJSON from "../../api/Video.json"

import "./Video.scss"
import ScrollableAnchor from 'react-scrollable-anchor'

class Video extends Component {
  constructor() {
    super();
    this.isMobile = this.isMobile.bind(this);
    this.state = {
      isDownloadActive: false,
      watched_video: false,
      watched_full: false
    }
  }
  isMobile() {
    if (navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      return true;
    } else {
      return false;
    }
  }
  componentDidMount() {
    var container = this.player;
    window.flowplayer.conf.fullscreen = true;
    window.flowplayer((api, root) => {
      var fsbutton = root.querySelector(".fp-fullscreen");

      if (this.isMobile()) {
        container.addEventListener("click", () => {
          api.fullscreen();
        });
      }
      if (!this.isMobile()) {
        api.on("ready", function () {
          root.querySelector(".fp-controls").appendChild(fsbutton);
        });
      }
    });
    window.flowplayer(container, {
      key: '$509034830680622',
      autoplay: true,
      muted: (this.isMobile() ? true : false),
      analytics: "UA-5536870-34",
      fullscreen: true,
      native_fullscreen: true,
      ratio: 9 / 16,
      buffering: false,
      mouseoutTimeout: 1500,
      share: false,
      hlsjs: {
        maxMaxBufferLength: 60
      },
      cuepoints: [5.0, 12.5, 25.0, 37.5, 48.0],
      loop: true,
      clip: {
        sources: [
          {
            type: "application/x-mpegurl",
            src: (this.isMobile() ? dataJSON.srcM3U8.replace("ynethd-i.akamaihd.net", "vod.ynet-cdnwiz.com") : dataJSON.srcM3U8)
          },
          {
            type: "video/mp4",
            src: dataJSON.src
          }
        ]
      }
    }).on("cuepoint", (e, api, cuepoint) => {
      switch (cuepoint.time) {
        case 5:
          var cup = "10%";
          break;
        case 12.5:
          var cup = "25%";
          break;
        case 25:
          var cup = "50%";
          break;
        case 37.5:
          var cup = "75%";
          break;
        case 48:
        this.setState({
          watched_full: true
        })
          var cup = "100%";
          break;
      }
      if (this.state.watched_video && !this.state.watched_full) {
        window.dataLayer.push({
          'event': 'GA_Event',
          'Category': 'nespresso',
          'Action': 'Video_Duration',
          'Label': cup
        });
      }
    });
    if (typeof (Storage) !== "undefined") {
      if (window.sessionStorage.getItem("watched_video")) {
        this.setState({
          watched_video: true,
          watched_full: false,
        })
      } else {
        window.sessionStorage.setItem("watched_video", true);
      }
    }
  }
  downloadedFullStory() {
    window.dataLayer.push({
      'event': 'GA_Event',
      'Category': 'nespresso',
      'Action': 'Video_Downloaded_FullStory'
    });
    window.open(dataJSON.downloadLink, "_blank");
  }
  /*

        var elem = window.document.getElementById('INDmenu-btn');
        var event = new Event('click');
        elem.dispatchEvent(event);
        */
  render() {
    return (
      <section className="section section-video" ref={(node) => { this.node = node }}>
        <ScrollableAnchor id="video">
          <div className="padding">
            <div className="container">
              <div className="headline">
                <h3 dangerouslySetInnerHTML={{__html: dataJSON.text}}></h3>
              </div>
              <div className="player-wrapper">
                <div id="player" ref={(player) => { this.player = player }} data-autoplay="true" data-loop="true" className="flowplayer fp-full fixed-controls play-button fp-mute"></div>
                <div className={`download`} onClick={this.downloadedFullStory}>
                  <div className="icon"></div>
                  <div className="teaser">
                    {dataJSON.downloadText}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ScrollableAnchor>
      </section>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/Components/Video/Video.js